import { Component, OnInit, Input, ViewChild, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RemoteApiService } from '../payment/servise/remote-api.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-channel-list',
  templateUrl: './channel-list.component.html',
  styleUrls: ['./channel-list.component.scss']
})
export class ChannelListComponent implements OnInit {
  API = {
    VIEW_CHANNEL_LIST: "viewChannelList",
    };
  
    pack :any;
  constructor(public dialog: MatDialog,
    public dialogRef:MatDialogRef<ChannelListComponent>,
    private remoteapi: RemoteApiService, 
    @Inject(MAT_DIALOG_DATA)
    public data: {
      filter(arg0: (item: any) => any): unknown; defaultValue: any 
},) {
    
   }

   channelList :any =[];
   filteredList = [];

  ngOnInit() {
console.log("value is "+this.data.defaultValue)
    let data ={ 
      packageId:this.data.defaultValue
    };
    this.remoteapi
      .postURLEncodedExecuteAPI(
        environment.apiUrl + this.API.VIEW_CHANNEL_LIST,data
    )      .subscribe((res) => {
      this.channelList=res
      this.filteredList=this.channelList;
      console.log("channel list is "+ this.channelList);
    });

  }

  searchText: string;
search() {
  debugger
  if (!this.searchText) {
    this.channelList = this.channelList;
  } else {
    this.channelList=this.channelList.filter((item) =>
      item.title.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }
}

  close(){
    this.dialogRef.close()
  }

  filterItems(searchTerm) {
    if(searchTerm){
    this. filteredList = this.channelList.filter(item =>
      item.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
   }else{
    this.filteredList=this.channelList
   }
   }
   
}
